import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { JAKARTA_AREAS, OTHER_AREAS } from "@/lib/constants";

export default function Coverage() {
  return (
    <section id="area-layanan" data-testid="coverage-section" className="py-24 lg:py-40 border-t border-ink/10 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[400px] w-[600px] ice-glow -z-10" />
      <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-brand-ink mb-4">( Area Layanan )</p>
          <h2 className="font-display font-extrabold uppercase tracking-tight leading-[0.95] text-5xl md:text-6xl lg:text-7xl">
            Area layanan
            <br />
            <span className="text-stroke">Sanjaya Service</span>
          </h2>
          <p className="mt-6 text-base text-ink/55">
            Melayani wilayah <span className="text-ink font-semibold">Jakarta dan sekitarnya</span>.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mt-12"
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-ink/40 mb-4">Jakarta</p>
          <div className="flex flex-wrap justify-center gap-3 lg:gap-4">
            {JAKARTA_AREAS.map((area) => (
              <span
                key={area.slug}
                data-testid={`area-pill-${area.slug}`}
                className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-5 py-2.5 lg:px-7 lg:py-3.5 font-display font-bold text-sm lg:text-lg hover:border-brand hover:text-brand-ink transition-colors duration-300"
              >
                <MapPin size={15} className="text-brand-ink" />
                {area.name}
              </span>
            ))}
          </div>

          <p className="mt-10 font-mono text-[11px] uppercase tracking-[0.3em] text-ink/40 mb-4">
            Sekitar Jakarta
          </p>
          <div className="flex flex-wrap justify-center gap-3 lg:gap-4">
            {OTHER_AREAS.map((area) => (
              <span
                key={area.slug}
                data-testid={`area-pill-${area.slug}`}
                className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-5 py-2.5 lg:px-7 lg:py-3.5 font-display font-bold text-sm lg:text-lg hover:border-brand hover:text-brand-ink transition-colors duration-300"
              >
                <MapPin size={15} className="text-brand-ink" />
                {area.name}
              </span>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mx-auto mt-14 max-w-4xl grid md:grid-cols-2 gap-6 text-left"
        >
          <div className="border border-ink/10 bg-white p-8">
            <h2 className="font-display font-extrabold uppercase tracking-tight text-2xl mb-4">
              Service AC <span className="text-brand-ink">Jakarta</span>
            </h2>
            <p className="text-sm text-ink/60 leading-relaxed">
              Sanjaya Service melayani kebutuhan service dan perbaikan AC di Jakarta dan sekitarnya — meliputi
              Jakarta Pusat, Jakarta Barat, Jakarta Selatan, Jakarta Timur, dan Jakarta Utara. Cuci AC,
              isi/tambah freon, hingga penanganan AC tidak dingin dan bocor dikerjakan di lokasi Anda.
            </p>
          </div>
          <div className="border border-ink/10 bg-white p-8">
            <h2 className="font-display font-extrabold uppercase tracking-tight text-2xl mb-4">
              Service Kulkas <span className="text-brand-ink">Jakarta</span>
            </h2>
            <p className="text-sm text-ink/60 leading-relaxed">
              Sanjaya Service juga melayani perbaikan kulkas bagi pelanggan di Jakarta — dari kulkas yang tidak
              dingin atau kurang dingin, bocor, hingga masalah kompresor dan sistem pendingin, baik untuk rumah
              tangga maupun usaha.
            </p>
          </div>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.35 }}
          data-testid="coverage-seo-paragraph"
          className="mx-auto mt-14 max-w-3xl border border-ink/10 bg-white p-8 text-sm md:text-base text-ink/60 leading-relaxed text-left"
        >
          Sanjaya Service melayani kebutuhan service AC, kulkas, mesin cuci, mesin laundry, mesin pengering
          laundry, dan showcase kaca di wilayah Jakarta dan sekitarnya. Pelanggan dapat menghubungi Sanjaya
          Service melalui WhatsApp untuk mendapatkan informasi layanan dan jadwal teknisi.
        </motion.p>
      </div>
    </section>
  );
}
